import { useEffect, useState } from "react";
import api, { fmtUSD, fmtQty } from "@/lib/api";
import { Panel, Table, Empty } from "@/components/terminal";

export default function TaxLots() {
  const [lots, setLots] = useState(null);
  useEffect(() => { api.get("/tax/lots").then((r) => setLots(r.data)).catch(() => {}); }, []);
  if (!lots) return <div className="text-slate-500 font-mono text-sm">Loading…</div>;
  return (
    <div className="space-y-5" data-testid="tax-lots-page">
      <h2 className="font-display text-xl font-bold">Tax Lots</h2>
      <Panel title="Acquisition Lots (FIFO default; HIFO and Specific ID supported structurally)" testId="tax-lots-panel">
        {lots.length === 0 ? <Empty>No tax lots. Purchases create lots that establish cost basis.</Empty> : (
          <Table testId="tax-lots-table" head={[{ label: "Lot" }, { label: "Acquired" }, { label: "Asset" }, { label: "Qty", num: true }, { label: "Remaining", num: true }, { label: "Price", num: true }, { label: "Total Cost", num: true }, { label: "Fees", num: true }, { label: "Source" }]}>
            {lots.map((l) => (
              <tr key={l.id} className={`hover:bg-[#222630] ${l.remaining_quantity <= 0 ? "opacity-40" : ""}`} data-testid={`lot-row-${l.id.slice(0, 8)}`}>
                <td className="td-cell font-mono text-slate-500">{l.id.slice(0, 8)}</td>
                <td className="td-cell font-mono whitespace-nowrap">{new Date(l.acquired_at).toLocaleString()}</td>
                <td className="td-cell font-semibold">{l.asset}</td>
                <td className="td-num">{fmtQty(l.quantity)}</td>
                <td className="td-num">{fmtQty(l.remaining_quantity)}</td>
                <td className="td-num">{fmtUSD(l.price)}</td>
                <td className="td-num">{fmtUSD(l.total_cost)}</td>
                <td className="td-num">{fmtUSD(l.fees)}</td>
                <td className="td-cell text-slate-500">{l.source}</td>
              </tr>
            ))}
          </Table>
        )}
      </Panel>
      <p className="text-[10px] text-slate-600">Tax methodology never changes automatically. Lot-level analysis is generated before any sale.</p>
    </div>
  );
}
